import React, { useState } from 'react'
import imgUrl from '../assets/images/imgUrl'
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Box,
  Typography,
} from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { apiServices } from "../services/apiServices";
import Swal from 'sweetalert2';

const countries = ["Country", "USA", "India", "UK", "Germany", "Australia"];

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    country: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });

  const [countryCode, setCountryCode] = useState('+91');
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Form Data:", formData);

    // Add your API call here
    setLoading(true);
        try {
          const contactData = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            contactNumber: `${countryCode} ${formData.mobile}`,
            query: formData.message,
          };
    
          console.log("Sending contact data:", contactData);
    
          const response = await apiServices.postAPI("contact-admin", contactData);
          console.log("Contact API response:", response);
    
          if (response.status === 200 || response.status === 201) {
            // Show success message with SweetAlert
            Swal.fire({
              title: 'Success!',
              text: 'Email sent successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
              confirmButtonColor: '#214F7D'
            });
    
            // Clear all form fields after successful submission
            setFormData({
              firstName: "",
              lastName: "",
              countryCode: "+1",
              mobile: "",
              designation: "",
              email: "",
              subject: "",
              message: "",
            });
          }
        } catch (error) {
          console.error("Contact submission failed:", error);
          setAlert({ show: true, type: "error", message: "Failed to send message. Please try again." });
        } finally {
          setLoading(false);
        }
  };

  return (
    <div className='homeMainWrapper biographyWrapper awardsWrapper thoughtLeadershipwrapper eventsWrapper contactWrapper'>
      <div className='homeBackground'>
        <div className='upperImage'>
          <img src={imgUrl.smileLogo} alt='smile logo' />
        </div>
      </div>

      {/* contact form */}

      <Box className="d-flex-align-center-justify-center">
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid size={12} className="homeSections">
            <div className='coloredBoxes mt-30px'>
              <div className='blueBox'></div>
              <div className='purpleBox'></div>
              <div className='blackBox'></div>
              <div className='greyBox'></div>
              <div className='pinkBox'></div>
            </div>
            <Typography className='headings sectionHeading blackTitles'>
              Contact Form
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* contact form section box */}
      <Box
        sx={{
          backgroundColor: "#f2f2f2",
          padding: 4,
          maxWidth: 600,
          margin: "0 auto",
          borderRadius: 2,
        }}
        className="contactMainSection mb-40px"
        mt={5}
      >
        <form className="contactForm" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                placeholder="First Name"
                variant="outlined"
                size="small"
                value={formData.firstName}
                onChange={(e) =>
                  handleInputChange("firstName", e.target.value)
                }
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                placeholder="Last Name"
                variant="outlined"
                size="small"
                value={formData.lastName}
                onChange={(e) =>
                  handleInputChange("lastName", e.target.value)
                }
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth className='countryLabel'>
                <Select
                  value={formData.country}
                  size="small"
                  onChange={(e) =>
                    handleInputChange("country", e.target.value)
                  }
                  displayEmpty
                >
                  {countries.map((country, i) => (
                    <MenuItem
                      key={i}
                      value={country}
                      disabled={country === "Country"}
                    >
                      {country}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                placeholder="Mobile (optional)"
                variant="outlined"
                size="small"
                value={formData.mobile}
                onChange={(e) =>
                  handleInputChange("mobile", e.target.value)
                }
              />
            </Grid>

            <Grid size={12}>
              <TextField
                fullWidth
                placeholder="Email"
                variant="outlined"
                size="small"
                value={formData.email}
                onChange={(e) =>
                  handleInputChange("email", e.target.value)
                }
              />
            </Grid>

            <Grid size={12}>
              <TextField
                fullWidth
                placeholder="Subject"
                variant="outlined"
                size="small"
                value={formData.subject}
                onChange={(e) =>
                  handleInputChange("subject", e.target.value)
                }
              />
            </Grid>

            <Grid size={12}>
              <TextField
                fullWidth
                placeholder="Message"
                multiline
                rows={4}
                variant="outlined"
                size="small"
                value={formData.message}
                onChange={(e) =>
                  handleInputChange("message", e.target.value)
                }
              />
            </Grid>

            <Grid size={12} textAlign="center">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  color: "#fff",
                  borderRadius: "50px",
                  fontWeight: "bold",
                  px: 3,
                  textTransform: "capitalize",
                  fontSize: "20px"
                }}
                className="contactSubmitButton"
              >
                SUBMIT
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>

      {/* Rest of your component remains unchanged */}
    </div>
  )
}

export default Contact;